// this file handles the maps on Villa and Tour Detail pages
function initMap() {
	const $map = jQuery('#map');
	var loc;  
	var KMLsrc;
	if (!$map.length) return;
	const mapType = $map.data('type');
	const mapZoom = mapType == 'villa' ? 8 : 14;
	var mapCenter = new google.maps.LatLng(-19.257753, 146.823688);
	if (mapType == 'villa') {
		const lat = jQuery('.marker').data('lat');
		const lng = jQuery('.marker').data('lng');
		loc = jQuery('.marker').data('location');
		mapCenter = new google.maps.LatLng(lat, lng);
		console.log('loading villa at '+lat+'lat and '+lng+'lng', loc, typeof loc);
	} else {
		KMLsrc = $map.text().trim();
		KMLsrc = encodeURI(KMLsrc);
	}
	const mapStyles = [
	      {
	          "featureType": "all",
	          "elementType": "labels.text.fill",
	          "stylers": [
	              {
	                  "saturation": 36
	              },
	              {
	                  "color": "#333333"
	              },
	              {
	                  "lightness": 40
	              }
	          ]
	      },
	      {
	          "featureType": "all",
	          "elementType": "labels.text.stroke",
	          "stylers": [
	              {
	                  "visibility": "on"
	              },
	              {
	                  "color": "#ffffff"
	              },
	              {
	                  "lightness": 16
	              }
	          ]
	      },
	      {
	          "featureType": "all",
	          "elementType": "labels.icon",
	          "stylers": [
	              {
	                  "visibility": "off"
	              }
	          ]
	      },
	      {
	          "featureType": "administrative",
	          "elementType": "geometry.fill",
	          "stylers": [
	              {
	                  "color": "#fefefe"
	              },
	              {
	                  "lightness": 20
	              }
	          ]
	      },
	      {
	          "featureType": "administrative",
	          "elementType": "geometry.stroke",
	          "stylers": [
	              {
	                  "color": "#fefefe"
	              },
	              {
	                  "lightness": 17
	              },
	              {
	                  "weight": 1.2
	              }
	          ]
	      },
	      {
	          "featureType": "landscape",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#f5f5f5"
	              },
	              {
	                  "lightness": 20
	              }
	          ]
	      },
	      {
	          "featureType": "poi",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#f5f5f5"
	              },
	              {
	                  "lightness": 21
	              }
	          ]
	      },
	      {
	          "featureType": "poi.park",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#dedede"
	              },
	              {
	                  "lightness": 21
	              }
	          ]
	      },
	      {
	          "featureType": "road.highway",
	          "elementType": "geometry.fill",
	          "stylers": [
	              {
	                  "color": "#c9c9c9"
	              },
	              {
	                  "lightness": 17
	              }
	          ]
	      },
	      {
	          "featureType": "road.highway",
	          "elementType": "geometry.stroke",
	          "stylers": [
	              {
	                  "color": "#ffffff"
	              },
	              {
	                  "lightness": 29
	              },
	              {
	                  "weight": 0.2
	              }
	          ]
	      },
	      {
	          "featureType": "road.arterial",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#ffffff"
	              },
	              {
	                  "lightness": 18
	              }
	          ]
	      },
	      {
	          "featureType": "road.local",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#ffffff"
	              },
	              {
	                  "lightness": 16
	              }
	          ]
	      },
	      {
	          "featureType": "transit",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#f2f2f2"
	              },
	              {
	                  "lightness": 19
	              }
	          ]
	      },
	      {
	          "featureType": "water",
	          "elementType": "geometry",
	          "stylers": [
	              {
	                  "color": "#c9c9c9"
	              },
	              {
	                  "lightness": 17
	              }
	          ]
	      }
	];

	var mapObj;

	mapObj = new google.maps.Map(document.getElementById("map"), {
	    center: mapCenter,
	    zoom: mapZoom,
	    disableDefaultUI: true,
	    styles: mapStyles,      
	});

	const iconBase = "/wp-content/themes/hostedVillas/public/img/";

	if (mapType == 'villa') { 
		// add pin for Villa Map
		const marker = new google.maps.Marker({
		  position: mapCenter,
		  map: mapObj,
		  icon: {
		    url: iconBase + "pin.svg",
		    labelOrigin: {x: 50, y: -20},
		  },
		  label: {
		    text: loc,
		    className: 'map-label',
		  },
		});
	} else {
		// add KML for Tours Map
		console.log('loading KML from: '+KMLsrc);

    jQuery.get(KMLsrc,function(data){
    	$data = jQuery(data);
    	$markers = $data.find('Placemark');
    	mapObj.markers = [];
    	$markers.each(function(){
    		var coordString = jQuery(this).find('coordinates').text();
    		var latlngStr = coordString.split(",",2);
				var lat = parseFloat(latlngStr[1]);
				var lng = parseFloat(latlngStr[0]);
    		var pos = new google.maps.LatLng(lat, lng);
    		var loc = jQuery(this).find('name').text();   		
    		const marker = new google.maps.Marker({
				  position: pos,
				  map: mapObj,
				  icon: {
				    url: iconBase + "pin.svg",
				    labelOrigin: {x: 50, y: -20},
				  },
				  label: {
				    text: loc,
				    className: 'map-label',
				  },
				});
				mapObj.markers.push( marker );
    	})

    	centerMap(mapObj);

    });
	}
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );
    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}